import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { searchDealers } from '@/api/dealers';
import { getRequestApprovalInfo, updateRequestApprovalLedger } from '@/api/ledgers';
import { searchProducts } from '@/api/products';
import { getSettings, updateSetting } from '@/api/settings';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { AdminModule } from '@/store/modules/admin';
import { checkIsPrimaryAccountManager, isSuperAdmin } from '@/common';
let RequestApprovalLedgersDetails = class RequestApprovalLedgersDetails extends Vue {
  constructor() {
    super(...arguments);
    this.id = null;
    this.data = null;
    this.activeNames = ['products'];
    this.canManageApprovals = false;
    this.paymentSubTypeOptions = [];
    this.dealerListLoading = false;
    this.dealerList = [];
    this.dialogVisible = false;
    this.newSubType = null;
    this.resetSubType = null;
    this.productListLoading = false;
    this.products = [];
    this.selectedVariationId = null;
    this.saveLoading = false;
    this.actions = [{
      label: 'Credit',
      key: 'credit'
    }, {
      label: 'Debit',
      key: 'debit'
    }];
    this.paymentTypeOptions = [{
      label: 'Cash in Bank',
      key: 'Cash in Bank'
    }, {
      label: 'Cheque',
      key: 'Cheque'
    }, {
      label: 'Net Banking',
      key: 'Net Banking'
    }, {
      label: 'Credit Note',
      key: 'Credit Note'
    }, {
      label: 'Debit Note',
      key: 'Debit Note'
    }, {
      label: 'Return Payment',
      key: 'Return Payment'
    }, {
      label: 'Credit Note-Item Wise',
      key: 'Credit Note-Item Wise'
    }, {
      label: 'Debit Note-Item Wise',
      key: 'Debit Note-Item Wise'
    }, {
      label: 'Journal Voucher',
      key: 'Journal Voucher'
    }, {
      label: 'Goods Inwards',
      key: 'Purchase'
    }, {
      label: 'Credit Note Inward',
      key: 'Credit Note Inward'
    }];
  }
  async activated() {
    var _this$$route$params;
    const isAccountManager = AdminModule.roles.includes('Account Manager');
    const isPrimary = isAccountManager ? await checkIsPrimaryAccountManager(AdminModule.id) : false;
    this.canManageApprovals = isSuperAdmin() || isAccountManager && isPrimary;
    if (!this.canManageApprovals) {
      this.$message.error('You do not have permission to access this page');
      this.$router.replace('/');
      return;
    }
    if ((_this$$route$params = this.$route.params) !== null && _this$$route$params !== void 0 && _this$$route$params.id) {
      this.id = Number(this.$route.params.id);
      this.fetchData(this.id);
    } else {
      throw new Error('No id found in route params');
    }
    this.fetchLedgerSubTypes();
  }
  async fetchData(id) {
    try {
      const response = await getRequestApprovalInfo(id);
      this.data = response;
      console.log('Fetched Ledger Data:', this.data);
      if (this.data) {
        if (!this.data.CnDnProducts) {
          this.$set(this.data, 'CnDnProducts', []);
        }
        // Preload based on detected IDs
        if (this.data.dealerId) {
          var _this$data$dealer, _this$data$dealer2, _this$data$dealer3;
          this.dealerList = [{
            id: ((_this$data$dealer = this.data.dealer) === null || _this$data$dealer === void 0 ? void 0 : _this$data$dealer.id) || this.data.dealerId,
            name: ((_this$data$dealer2 = this.data.dealer) === null || _this$data$dealer2 === void 0 ? void 0 : _this$data$dealer2.name) || 'Dealer ' + this.data.dealerId,
            code: ((_this$data$dealer3 = this.data.dealer) === null || _this$data$dealer3 === void 0 ? void 0 : _this$data$dealer3.code) || ''
          }];
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  async _getProductList(query) {
    try {
      this.productListLoading = true;
      if (query && query.length > 2) {
        const response = await searchProducts({
          keyword: query
        });
        // Handle cases where response might be wrapped in a 'data' object
        this.products = Array.isArray(response) ? response : (response === null || response === void 0 ? void 0 : response.data) || [];
      } else {
        this.products = [];
      }
      this.productListLoading = false;
    } catch (err) {
      this.productListLoading = false;
      console.error('Product Search Error:', err);
    }
  }
  async addVariation() {
    if (!this.selectedVariationId) return;
    let selected = null;
    this.products.forEach(product => {
      product.productsVariation.forEach(item => {
        if (item.id === this.selectedVariationId) {
          selected = {
            productId: product.id,
            hsnCode: product.hsnCode,
            productsVariationId: item.id,
            name: product.name,
            variationName: item.name,
            nettRate: item.mrp,
            mrp: item.mrp,
            oldMrp: item.oldMrp,
            quantity: 1,
            amount: item.mrp
          };
        }
      });
    });
    if (selected) {
      this.data.CnDnProducts.push({
        ...selected,
        policiesDiscount: 0,
        schemesDiscount: 0,
        moqDiscount: 0,
        extraDiscount: 0
      });
      this.selectedVariationId = null;
    }
  }
  async removeProduct(index) {
    try {
      const confirm = await this.$confirm('Are you sure you want to remove this product?', 'Confirmation', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      });
      if (confirm === 'confirm') {
        this.data.CnDnProducts.splice(index, 1);
      }
    } catch (error) {
      // User cancelled
    }
  }
  handleQuantity(index) {
    const row = this.data.CnDnProducts[index];
    const mrp = parseFloat(row.mrp) || 0;
    // Apply discounts sequentially as per other ledger components
    let discountedPrice = mrp;
    discountedPrice -= discountedPrice * (parseFloat(row.policiesDiscount) || 0) / 100;
    discountedPrice -= discountedPrice * (parseFloat(row.schemesDiscount) || 0) / 100;
    discountedPrice -= discountedPrice * (parseFloat(row.moqDiscount) || 0) / 100;
    discountedPrice -= discountedPrice * (parseFloat(row.extraDiscount) || 0) / 100;
    const amount = discountedPrice * (row.quantity || 0);
    this.$set(this.data.CnDnProducts[index], 'amount', amount.toFixed(2));
  }
  async handleSave() {
    if (!this.canManageApprovals) {
      this.$message.error('You do not have permission to perform this action');
      return;
    }
    try {
      this.saveLoading = true;
      await updateRequestApprovalLedger(this.data);
      this.$message.success('Ledger updated successfully');
    } catch (error) {
      console.error('Save failed:', error);
      this.$message.error('Failed to update ledger');
    } finally {
      this.saveLoading = false;
    }
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query || '');
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        return;
      }
      this.dealerListLoading = true;
      this.dealerList = await searchDealers({
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        fromLedger: true
      });
    } catch (error) {
      console.error('Dealer search failed', error);
    } finally {
      this.dealerListLoading = false;
    }
  }
  openDialog() {
    this.dialogVisible = true;
  }
  async addSubType() {
    if (this.newSubType) {
      try {
        // Fetch the current settings
        const data = await getSettings({
          enabled: true
        });
        if (data.length > 0 && Array.isArray(data[0].ledgerSubtypes)) {
          const settings = data[0];
          const ledgerSubtypes = settings.ledgerSubtypes;
          // Check if the new subtype already exists
          if (!ledgerSubtypes.includes(this.newSubType)) {
            // Add the new subtype
            ledgerSubtypes.push(this.newSubType);
            // Update the settings in the database
            await updateSetting(1, {
              ledgerSubtypes
            });
            // Optionally, update the local paymentSubTypeOptions
            this.paymentSubTypeOptions = ledgerSubtypes.map(item => ({
              label: item,
              key: item
            }));
          } else {
            this.$message.warning('Subtype already exists.');
          }
        } else {
          console.log('No valid settings found.');
        }
      } catch (error) {
        console.error('Error adding subtype:', error);
      }
    }
    // Reset the input and close the dialog
    this.newSubType = null;
    this.dialogVisible = false;
  }
  async fetchLedgerSubTypes() {
    const data = await getSettings({
      enabled: true
    });
    if (data.length > 0 && Array.isArray(data[0].ledgerSubtypes)) {
      this.paymentSubTypeOptions = data[0].ledgerSubtypes.map(item => ({
        label: item,
        key: item
      }));
    } else {
      this.paymentSubTypeOptions = []; // Handle case where data is not found
    }
  }
  formatDate(date) {
    if (!date) return '';
    return moment(date).format('DD/MM/YYYY');
  }
};
RequestApprovalLedgersDetails = __decorate([Component({
  name: 'RequestApprovalLedgersDetails'
})], RequestApprovalLedgersDetails);
export default RequestApprovalLedgersDetails;